<h1>Approvals</h1>

<mat-accordion multi="true">
  <mat-expansion-panel *ngIf="pipelines && pipelines.failed && pipelines.failed.length > 0">
    <mat-expansion-panel-header>
      <mat-panel-title>FAILED PIPELINES</mat-panel-title>
    </mat-expansion-panel-header>
    <ul>
      <li *ngFor="let failed of pipelines.failed">{{failed.pipelineName}}</li>
    </ul>
  </mat-expansion-panel>
  <mat-expansion-panel *ngFor="let stage of stages">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Deploying To {{stage.name}}
      </mat-panel-title>
      <mat-panel-description><span class="approval-status">{{stage.statusMessage}}</span></mat-panel-description>
    </mat-expansion-panel-header>

    <mat-tab-group>
      <mat-tab label="Changes">
        <ul>
          <li *ngFor="let change of stage.changes">{{change}}</li>
        </ul>
      </mat-tab>
      <mat-tab label="Affected Pipelines">
        <ul>
          <li *ngFor="let pending of stage.pending">{{pending.pipelineName}}</li>
        </ul>
      </mat-tab>
      <mat-tab label="Currently Deploying">
        <ul>
          <li *ngFor="let deploying of stage.deploying">{{deploying.pipelineName}}</li>
        </ul>
      </mat-tab>
    </mat-tab-group>

    <mat-action-row>
      <ng-container *ngIf="stage.requireApproval">
        <button *ngIf="stage.pendingCore && stage.pendingCore.length > 0" mat-raised-button
                color="warn" [disabled]="!stage.canApproveCore"
                (click)="approveChanges(stage.pendingCore)">
          Approve Main Infra
        </button>

        <button *ngIf="stage.pendingConfig && stage.pendingConfig.length > 0" mat-raised-button
                color="warn" [disabled]="!stage.canApproveConfig"
                (click)="approveChanges(stage.pendingConfig)">
          Approve Config
        </button>

        <button *ngIf="stage.pendingTemplates && stage.pendingTemplates.length > 0" mat-raised-button
                color="warn" [disabled]="!stage.canApproveTemplates"
                (click)="approveChanges(stage.pendingTemplates)">
          Approve Templates
        </button>

        <ng-container *ngIf="stage.pendingCore === undefined || stage.pendingCore.length === 0">
          <button *ngIf="stage.pendingInfra && stage.pendingInfra.length > 0" mat-raised-button
                  color="warn" [disabled]="!stage.canApproveInfra"
                  (click)="approveChanges(stage.pendingInfra)">
            Approve Infra
          </button>
          <button *ngIf="stage.pendingCode && stage.pendingCode.length > 0" mat-raised-button
                  color="warn" [disabled]="!stage.canApproveCode"
                  (click)="approveChanges(stage.pendingCode)">
            Approve Code
          </button>
          <button mat-raised-button color="warn"
                  [disabled]="!stage.canApproveAll"
                  (click)="approveChanges(stage.pending)">
            Approve All Changes
          </button>
        </ng-container>

      </ng-container>
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>
